'use strict';

import React         from 'react';
import {Link}        from 'react-router';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections.js";
import ActiveOrdersStore from "../../stores/ActiveOrdersStore.js";
import {render} from "react-dom";
import ReadyForDeliveryOrders from './ReadyForDeliveryOrders';
import CompletedOrders from './CompletedOrders';

import Tabs from './Tabs';

// const propTypes = {
//     currentUser: React.PropTypes.object
// };

class ActiveOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            allOrders:[],
            filteredOrders:[]
        };
        this.updateActiveOrders=this.updateActiveOrders.bind(this);


    }
    componentWillMount() {
        this.setState({
            allOrders:ActiveOrdersStore.getAll(),
            filteredOrders:ActiveOrdersStore.getFiltered()
        });
        ActiveOrdersStore.on("change",this.updateActiveOrders);
        Connections.getActiveOrders();
    }
    updateActiveOrders(){
        this.setState({
            allOrders:ActiveOrdersStore.getAll(),
            filteredOrders:ActiveOrdersStore.getFiltered()
        });
    }
    getImageName(imageName){
        return Connections.getProduceImageLink() +imageName.replace(" ","").toLowerCase()+".jpg";

    }



    render() {
        return (
            <DocumentTitle title="Khula - Active Orders">
                <div className="main-content">





                    {/*<div className="order-page-heading">*/}
                    {/*<h2>Your orders are currently being harvested</h2>*/}
                    {/*<p><br/></p>*/}

                    {/*<h5>Our farmers have received your order and are confirming delivery</h5>*/}


                    {/*</div>*/}

                    <div className="all-orders-container">
                        <Tabs>
                            <div label="Busy Harvesting">



                                <div className="   uk-overflow-auto">
                                    <table className="uk-table uk-table-hover uk-table-responsive uk-table-middle uk-table-divider">
                                        <thead>
                                        <tr>

                                            <th className="uk-width-small">Ordered Date</th>
                                            <th className="uk-table-shrink"></th>
                                            <th className="uk-table-shrink">Produce</th>
                                            <th className="uk-table-shrink uk-text-nowrap">Progress KG</th>
                                            <th className="uk-table-expand">Description</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.filteredOrders.map((order, i) =>
                                            <tr key={order.order_id}>

                                                <td className="uk-text-nowrap"><p className="uk-text-meta uk-margin-remove-top"><time>{order.inserted_on}</time></p></td>
                                                <td><img className="avalibleImage uk-preserve-width uk-border-circle" src={this.getImageName(order.produce)} width="40" alt=""/></td>
                                                <td className="">{order.produce}</td>
                                                <td className="uk-text-nowrap">{order.quantity-order.quantity_left}/{order.quantity} kg</td>
                                                <td className="uk-table-link">
                                                    <span className="uk-link-reset">{order.description}</span>
                                                </td>


                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            <div label="In the truck">

                                <ReadyForDeliveryOrders/>

                            </div>
                            <div label="Completed deliveries">
                                <CompletedOrders/>
                            </div>
                        </Tabs>
                    </div>


                </div>
            </DocumentTitle>
        );
    }

}

// ActiveOrders.propTypes = propTypes;

export default ActiveOrders;


// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/ActiveOrders.js